import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmModule } from '@shared/modules/confirm/confirm.module';
import { DynamicModalModule } from '@shared/modules/dynamic-modal/dynamic-modal.module';
import { SessionCheckComponent } from './session-check.component';
import { SessionCheckService } from './session-check.service';

@NgModule({
  imports: [CommonModule, DynamicModalModule, MatIconModule, ConfirmModule, SessionCheckComponent],
  providers: [SessionCheckService]
})
export class SessionCheckModule {}
